module.exports = __webpack_public_path__ + "static/img/24.4482ea3d.png";